'use strict';
var basePath; // = window.hm_chairselectorbasepath;
if (window.location.hostname === 'localhost' || window.location.hostname === '10.0.2.2'|| window.location.hostname === 'selector.hmibrand.com') {
	basePath = '/'; //end with forward slash
} else {
	basePath = '/content/dam/hmicom/microsite_assets/chair_selector/';
}

module.exports = {
	getPath: function(p) {
		return basePath + p;
	}
};
